<div class="table-container">
  <p-table [value]="items"
           [tableStyle]="{ 'min-width': '50rem' }"
           [paginator]="showTablePaginator"
           [rows]="5"
  >
    <ng-template pTemplate="header">
      <tr class="table-row">
        <th *ngIf="showCheck" class="table-header"><input type="checkbox" name="main-checkbox" id="th-main-checkbox"
                                                          [checked]="selectAll"
                                                          [(ngModel)]="selectAll"
                                                          (change)="addItemsToList()" (click)="clickCheckAll($event)">
        </th>
        <th class="table-header" *ngFor="let header of tableHeaders"
            [style.width]="header.width ? header.width : 'auto'">
          <div class="d-flex aligns-items-center justify-content-between">
            <span>{{ header.title }}</span>
            <div *ngIf="header.showIcon" class="cursor-pointer" (click)="orderTable(header.orderName)">
              <svg width="18" height="16" viewBox="0 0 18 16" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M13.1667 14.6666L9.83333 11.3333M4.83333 11.3333V1.33325V11.3333ZM4.83333 1.33325L1.5 4.66659L4.83333 1.33325ZM4.83333 1.33325L8.16667 4.66659L4.83333 1.33325ZM13.1667 4.66659V14.6666V4.66659ZM13.1667 14.6666L16.5 11.3333L13.1667 14.6666Z"
                  stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
      <tr *ngIf="items && items.length > 0"
          [ngStyle]="{ 'background-color': (rowIndex + 1) % 2 == 0 ? '#f1f1f1 ' : '' }" class="row-borders">
        <td class="row-borders" *ngIf="showCheck">
          <input type="checkbox" name="table-checkbox" class="table-checkbox" id="table-checkbox"
                 [checked]="item?.checked"
                 (change)="addSingleItem(item)">
        </td>
        <ng-container *ngIf="!loading; else loadingRows">
          <td class="row-borders" *ngFor="let header of tableHeaders"
              [style.width]="header.width ? header.width : 'auto'">
            <div *ngIf="header && header.format === ItemsTableFormatEnum.AMOUNT">
              <span *ngIf="isNumber(item[header.property]); else noNumberTemplate">
                {{ item[header.formatProperty] | currencySymbol }} {{ item[header.property] | number: '1.2-2' }}
              </span>
              <ng-template #noNumberTemplate>
                <span>{{ item[header.property] }}</span>
              </ng-template>
            </div>

            <div *ngIf="header && header.format === ItemsTableFormatEnum.HTML">
              <div [innerHTML]="sanitizeHTML(item[header.property])"
                   [className]="header?.htmlContainerClass ? header?.htmlContainerClass: ''">

              </div>
            </div>
            <span *ngIf="!header?.format && !header.action">
              {{ item[header.property] }}
            </span>
            <div *ngIf="header?.action">
              <div *ngIf="header.action === ItemsTableActionEnum.EDIT && item.action === ItemsTableActionEnum.EDIT"
                   class="cursor-pointer" (click)="onAction(ItemsTableActionEnum.EDIT, item)">
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M0 12.0499V14.5832C0 14.8166 0.183333 14.9999 0.416667 14.9999H2.95C3.05833 14.9999 3.16667 14.9582 3.24167 14.8749L12.3417 5.78322L9.21667 2.65822L0.125 11.7499C0.0416667 11.8332 0 11.9332 0 12.0499ZM14.7583 3.36655C15.0833 3.04155 15.0833 2.51655 14.7583 2.19155L12.8083 0.241553C12.4833 -0.0834473 11.9583 -0.0834473 11.6333 0.241553L10.1083 1.76655L13.2333 4.89155L14.7583 3.36655Z"
                    fill="#001865"/>
                </svg>
              </div>
            </div>

          </td>
        </ng-container>
        <ng-template #loadingRows>
          <td class="row-borders" *ngFor="let header of tableHeaders">
            <p-skeleton width="5rem"></p-skeleton>
          </td>
        </ng-template>
      </tr>
    </ng-template>
  </p-table>
  <!--    <div class="d-flex justify-content-center">-->
  <!--        <p-paginator-->
  <!--            #paginator-->
  <!--            (onPageChange)="onPageChange($event)"-->
  <!--            [first]="0"-->
  <!--            [rows]="5"-->
  <!--            [totalRecords]="count"-->
  <!--        ></p-paginator>-->
  <!--    </div>-->
</div>
